// extracted by mini-css-extract-plugin
module.exports = {"main":"AreaPageMain_main__3mVOU","mobileApp":"AreaPageMain_mobileApp__1OXeV","containerSlider":"AreaPageMain_containerSlider__2R1Zb"};